import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{! template-lint-disable no-pointer-down-event-binding }}
{{! template-lint-disable no-invalid-interactive }}
<li
  class="search-menu-assistant-item"
  {{on "keydown" this.onKeydown}}
  {{on "click" this.onClick}}
  data-usage={{@usage}}
>
  <a class="search-link" href={{this.href}}>
    <span aria-label={{i18n "search.title"}}>
      {{d-icon (or @icon "search")}}
    </span>

    {{#if this.prefix}}
      <span class="search-item-prefix">
        {{this.prefix}}
      </span>
    {{/if}}

    {{#if @withInLabel}}
      <span class="label-suffix">{{i18n "search.in"}}</span>
    {{/if}}

    {{#if @category}}
      <SearchMenu::Results::Type::Category @result={{@category}} />
      {{#if (and @tag @isIntersection)}}
        <span class="search-item-tag">
          {{d-icon "tag"}}{{@tag}}
        </span>
      {{/if}}
    {{else if @tag}}
      {{#if (and @isIntersection @additionalTags.length)}}
        <span class="search-item-tag">{{this.tagsSlug}}</span>
      {{else}}
        <span class="search-item-tag">
          <SearchMenu::Results::Type::Tag @result={{@tag}} />
        </span>
      {{/if}}
    {{else if @user}}
      <span class="search-item-user">
        <SearchMenu::Results::Type::User @result={{@user}} />
      </span>
    {{/if}}

    <span class="search-item-slug">
      {{#if @suffix}}
        <span class="label-suffix">{{@suffix}}</span>
      {{/if}}
      {{@label}}
    </span>
    {{#if @extraHint}}
      <span class="extra-hint">
        {{i18n "search.enter_hint"}}
      </span>
    {{/if}}
  </a>
</li>
*/
{
  "id": "N7WtofzZ",
  "block": "[[[11,\"li\"],[24,0,\"search-menu-assistant-item\"],[16,\"data-usage\",[30,1]],[4,[38,0],[\"keydown\",[30,0,[\"onKeydown\"]]],null],[4,[38,0],[\"click\",[30,0,[\"onClick\"]]],null],[12],[1,\"\\n  \"],[10,3],[14,0,\"search-link\"],[15,6,[30,0,[\"href\"]]],[12],[1,\"\\n    \"],[10,1],[15,\"aria-label\",[28,[37,1],[\"search.title\"],null]],[12],[1,\"\\n      \"],[1,[28,[35,2],[[28,[37,3],[[30,2],\"search\"],null]],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"prefix\"]],[[[1,\"      \"],[10,1],[14,0,\"search-item-prefix\"],[12],[1,\"\\n        \"],[1,[30,0,[\"prefix\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,3],[[[1,\"      \"],[10,1],[14,0,\"label-suffix\"],[12],[1,[28,[35,1],[\"search.in\"],null]],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,4],[[[1,\"      \"],[8,[39,5],null,[[\"@result\"],[[30,4]]],null],[1,\"\\n\"],[41,[28,[37,6],[[30,5],[30,6]],null],[[[1,\"        \"],[10,1],[14,0,\"search-item-tag\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"tag\"],null]],[1,[30,5]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]],[[[41,[30,5],[[[41,[28,[37,6],[[30,6],[30,7,[\"length\"]]],null],[[[1,\"        \"],[10,1],[14,0,\"search-item-tag\"],[12],[1,[30,0,[\"tagsSlug\"]]],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,1],[14,0,\"search-item-tag\"],[12],[1,\"\\n          \"],[8,[39,7],null,[[\"@result\"],[[30,5]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]]],[]],[[[41,[30,8],[[[1,\"      \"],[10,1],[14,0,\"search-item-user\"],[12],[1,\"\\n        \"],[8,[39,8],null,[[\"@result\"],[[30,8]]],null],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]],null]],[]]]],[]]],[1,\"\\n    \"],[10,1],[14,0,\"search-item-slug\"],[12],[1,\"\\n\"],[41,[30,9],[[[1,\"        \"],[10,1],[14,0,\"label-suffix\"],[12],[1,[30,9]],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[1,[30,10]],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,11],[[[1,\"      \"],[10,1],[14,0,\"extra-hint\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"search.enter_hint\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"],[13]],[\"@usage\",\"@icon\",\"@withInLabel\",\"@category\",\"@tag\",\"@isIntersection\",\"@additionalTags\",\"@user\",\"@suffix\",\"@label\",\"@extraHint\"],false,[\"on\",\"i18n\",\"d-icon\",\"or\",\"if\",\"search-menu/results/type/category\",\"and\",\"search-menu/results/type/tag\",\"search-menu/results/type/user\"]]",
  "moduleName": "discourse/components/search-menu/results/assistant-item.hbs",
  "isStrictMode": false
});